import { render } from "./ContactPage.vue?vue&type=template&id=d04310f0&scoped=true&ts=true"
import script from "./ContactPage.vue?vue&type=script&lang=ts"
export * from "./ContactPage.vue?vue&type=script&lang=ts"

import "./ContactPage.vue?vue&type=style&index=0&id=d04310f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d04310f0"]])

export default __exports__